import { render } from "./dictArea.vue?vue&type=template&id=a00178a0"
import script from "./dictArea.vue?vue&type=script&lang=js"
export * from "./dictArea.vue?vue&type=script&lang=js"

import exportComponent from "/home/jenkins/agent/workspace/yf-sassmc4ct_wyf-saas-web_master/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__